(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collar-home-station"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup() {
    if (reduce) return;
    document.querySelectorAll('[data-hs-parallax]:not([data-hs-init])').forEach(function (el) {
      el.setAttribute('data-hs-init', '1');
      el.style.willChange = 'transform';
      var sec = el.closest('[data-section-id]') || el;
      var ticking = false;
      function update() {
        ticking = false;
        var r = sec.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var center = r.top + r.height / 2;
        var p = (center - vh / 2) / (vh / 2 + r.height / 2);
        p = Math.max(-1, Math.min(1, p));
        el.style.transform = 'translate3d(0,' + (-p * 55).toFixed(1) + 'px,0)';
      }
      function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }
  if (document.readyState !== 'loading') { setup(); } else { document.addEventListener('DOMContentLoaded', setup); }
  document.addEventListener('shopify:section:load', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-recovery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var PT_CUR = (typeof window !== 'undefined' && window.PT_REC_CUR) || 'GBP';
  var PT_LOC = (typeof window !== 'undefined' && window.PT_REC_LOC) || 'en';
  function money(cents) {
    try { return new Intl.NumberFormat(PT_LOC, { style: 'currency', currency: PT_CUR, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) {
      try { return new Intl.NumberFormat(PT_LOC, { style: 'currency', currency: PT_CUR }).format(cents / 100); }
      catch (e2) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : (cents / 100).toFixed(2); }
    }
  }
  function ptUpdateIncluded(root, count) {
    var mult = Math.max(1, parseInt(count, 10) || 1);
    var box = root.querySelector('[data-pdp-inc]');
    if (!box) return;
    var saveLabel = root.getAttribute('data-save-label') || 'Save';
    var totalWas = 0, totalNow = 0;
    box.querySelectorAll('[data-pt-inc]').forEach(function (row) {
      var scales = row.getAttribute('data-scales') === 'true';
      var m = scales ? mult : 1;
      var compare = parseInt(row.getAttribute('data-compare'), 10) * m;
      var price = parseInt(row.getAttribute('data-price'), 10) * m;
      var isFree = row.getAttribute('data-free') === 'true';
      var qtyEl = row.querySelector('.pt-inc-qty');
      if (qtyEl) { if (scales && mult > 1) { qtyEl.textContent = mult + ' × '; qtyEl.style.display = 'inline'; } else { qtyEl.textContent = ''; qtyEl.style.display = 'none'; } }
      var wasEl = row.querySelector('.pt-inc-was'), nowEl = row.querySelector('.pt-inc-now'), freeEl = row.querySelector('.pt-inc-free');
      if (wasEl) wasEl.style.display = 'none';
      if (nowEl) nowEl.style.display = 'none';
      if (freeEl) freeEl.style.display = 'none';
      if (isFree) { if (wasEl) { wasEl.textContent = money(compare); wasEl.style.display = 'inline'; } if (freeEl) freeEl.style.display = 'inline'; }
      else if (price !== compare) { if (wasEl) { wasEl.textContent = money(compare); wasEl.style.display = 'inline'; } if (nowEl) { nowEl.textContent = money(price); nowEl.style.display = 'inline'; } }
      else if (nowEl) { nowEl.textContent = money(price); nowEl.style.display = 'inline'; }
      totalWas += compare; totalNow += price;
    });
    var saveEl = root.querySelector('[data-inc-save]'), wasT = root.querySelector('[data-inc-total-was]'), nowT = root.querySelector('[data-inc-total-now]');
    var savings = totalWas - totalNow;
    if (saveEl) { if (savings > 0) { saveEl.textContent = saveLabel + ' ' + money(savings); saveEl.hidden = false; } else saveEl.hidden = true; }
    if (wasT) { if (savings > 0) { wasT.textContent = money(totalWas); wasT.hidden = false; } else wasT.hidden = true; }
    if (nowT) nowT.textContent = money(totalNow);
    // Gallery SAVE badge shows the same value-stack saving
    root.querySelectorAll('[data-pdp-save-amt]').forEach(function (e) { e.textContent = money(savings); });
    var gbadge = root.querySelector('[data-pdp-save]'); if (gbadge) gbadge.style.display = savings > 0 ? '' : 'none';
  }
  function ptDelivery(root) {
    var el = root.querySelector('[data-pdp-deliv]');
    if (!el) return;
    var wrap = el.closest('[data-pdp-deliv-row]') || el;
    var cutoff = el.getAttribute('data-cutoff') || '14:00';
    var tz = el.getAttribute('data-tz') || 'Europe/London';
    // Active weekdays as JS day numbers (0=Sun … 6=Sat), e.g. "1,2,3" for Mon/Tue/Wed
    var days = (el.getAttribute('data-days') || '1,2,3').split(',').map(function (x) { return parseInt(x, 10); });
    var beforeText = el.getAttribute('data-before') || 'Order in the next {time} for same-day dispatch';
    var afterText = el.getAttribute('data-after') || 'Order before {cutoff} for same-day dispatch';
    function wallNow(z) { try { return new Date(new Date().toLocaleString('en-US', { timeZone: z })); } catch (e) { return null; } }
    function fmtCutoff(H, M) { var ap = H >= 12 ? 'pm' : 'am', hh = H % 12; if (hh === 0) hh = 12; return hh + (M ? ':' + (M < 10 ? '0' : '') + M : '') + ap; }
    function render() {
      try {
        var parts = String(cutoff).split(':'), H = parseInt(parts[0], 10), M = parseInt(parts[1] || '0', 10);
        if (isNaN(H) || isNaN(M)) throw 'bad';
        var now = wallNow(tz); if (!now) throw 'tz';
        var cutStr = fmtCutoff(H, M);
        // Not an active dispatch day → hide the whole row
        if (days.indexOf(now.getDay()) === -1) { wrap.style.display = 'none'; return; }
        wrap.style.display = '';
        var cutoffToday = new Date(now); cutoffToday.setHours(H, M, 0, 0);
        var remainMs = cutoffToday.getTime() - now.getTime();
        if (remainMs > 0) {
          // Midnight → cutoff: live countdown of time left today
          var mins = Math.floor(remainMs / 60000), h = Math.floor(mins / 60), mm = mins % 60;
          function u(n, s) { return n + ' ' + s + (n === 1 ? '' : 's'); }
          var bits = []; if (h > 0) bits.push(u(h, 'hr')); if (mm > 0) bits.push(u(mm, 'min')); if (!bits.length) bits.push(u(1, 'min'));
          el.textContent = beforeText.replace('{time}', bits.join(' ')).replace('{cutoff}', cutStr);
        } else {
          // Cutoff → midnight: static reminder, no ticking clock
          el.textContent = afterText.replace('{cutoff}', cutStr).replace('{time}', '');
        }
      } catch (e) { wrap.style.display = 'none'; }
    }
    render(); setInterval(render, 30000);
  }
  function initPdp(root) {
    var stage = root.querySelector('[data-pdp-stage]');
    var slides = root.querySelectorAll('.pdp-slide');
    var thumbs = root.querySelectorAll('.pdp-thumb');
    var thumbStrip = root.querySelector('[data-pdp-thumbs]');
    var slideCount = slides.length;
    var current = 0;
    function goToSlide(i) {
      if (slideCount < 1) return;
      if (i < 0) i = slideCount - 1; if (i >= slideCount) i = 0;
      current = i;
      slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === String(i)); });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-thumb') === String(i);
        t.classList.toggle('is-on', on);
        if (on && thumbStrip) { thumbStrip.scrollTo({ left: t.offsetLeft - (thumbStrip.clientWidth - t.clientWidth) / 2, behavior: 'smooth' }); }
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goToSlide(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    root.querySelectorAll('[data-thumbnav]').forEach(function (b) { b.addEventListener('click', function () { goToSlide(current + parseInt(b.getAttribute('data-thumbnav'), 10)); }); });
    if (stage) {
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { goToSlide(current + (dx < 0 ? 1 : -1)); } sx = null; }, { passive: true });
    }

    var idInput = root.querySelector('[data-pdp-id]');
    var priceEls = root.querySelectorAll('[data-pdp-price], [data-pdp-atc-price]');
    var saveEls = root.querySelectorAll('[data-pdp-save-amt], [data-pdp-save-amt2]');
    var saveRow = root.querySelector('[data-pdp-save-row]');
    var saveBadge = root.querySelector('[data-pdp-save]');
    var klarna = root.querySelector('[data-pdp-klarna]');
    var groups = root.querySelectorAll('.pdp-colour-group');
    var props = root.querySelectorAll('[data-prop]');
    var collars = root.querySelectorAll('.pdp-collar');

    function applyVariant(card) {
      var price = parseInt(card.getAttribute('data-price'), 10) || 0;
      var compare = parseInt(card.getAttribute('data-compare'), 10) || 0;
      var count = parseInt(card.getAttribute('data-count'), 10) || 1;
      if (idInput) idInput.value = card.getAttribute('data-vid');
      priceEls.forEach(function (e) { e.textContent = money(price); });
      if (klarna) klarna.textContent = money(Math.round(price / 3));
      collars.forEach(function (c) { c.classList.toggle('is-on', c === card); });
      groups.forEach(function (g) {
        var n = parseInt(g.getAttribute('data-colour-group'), 10);
        g.hidden = n > count;
      });
      props.forEach(function (p) { p.disabled = parseInt(p.getAttribute('data-prop'), 10) > count; });
      ptUpdateIncluded(root, count);
    }
    collars.forEach(function (c) { c.addEventListener('click', function () { applyVariant(c); }); });

    groups.forEach(function (g) {
      var n = g.getAttribute('data-colour-group');
      var nameEl = g.querySelector('[data-colour-name]');
      var prop = root.querySelector('[data-prop="' + n + '"]');
      g.querySelectorAll('.pdp-sw').forEach(function (sw) {
        sw.addEventListener('click', function () {
          g.querySelectorAll('.pdp-sw').forEach(function (x) { x.classList.remove('is-on'); });
          sw.classList.add('is-on');
          var val = sw.getAttribute('data-colour');
          if (nameEl) nameEl.textContent = val;
          if (prop) prop.value = val;
        });
      });
    });

    var active = root.querySelector('.pdp-collar.is-on') || root.querySelector('.pdp-collar');
    if (active) { applyVariant(active); } else { ptUpdateIncluded(root, 1); }
    ptDelivery(root);

    // Offer countdown — drives every [data-cd] in the section (top bar + at-button block)
    var cdEndEl = root.querySelector('[data-cd-end]');
    if (cdEndEl) {
      var end = new Date(cdEndEl.getAttribute('data-cd-end')).getTime();
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function setCd(key, val) { root.querySelectorAll('[data-cd="' + key + '"]').forEach(function (e) { e.textContent = val; }); }
      function tick() {
        if (isNaN(end)) return;
        var diff = end - Date.now();
        if (diff <= 0) { root.querySelectorAll('[data-cd-wrap]').forEach(function (e) { e.style.display = 'none'; }); return; }
        var dd = Math.floor(diff / 86400000), hh = Math.floor(diff % 86400000 / 3600000), mm = Math.floor(diff % 3600000 / 60000), ss = Math.floor(diff % 60000 / 1000);
        setCd('d', pad(dd)); setCd('h', pad(hh)); setCd('m', pad(mm)); setCd('s', pad(ss));
      }
      tick(); setInterval(tick, 1000);
    }

    // Membership popup
    var mpop = root.querySelector('[data-mpop]');
    if (mpop) {
      var mCur = mpop.getAttribute('data-cur') || '£';
      var mM = (mpop.getAttribute('data-m') || '').split(',');
      var mY = (mpop.getAttribute('data-y') || '').split(',');
      var mT = (mpop.getAttribute('data-t') || '').split(',');
      var divY = parseInt(mpop.getAttribute('data-div-y'), 10) || 13;
      var divT = parseInt(mpop.getAttribute('data-div-t'), 10) || 27;
      var bSuf = mpop.getAttribute('data-billed-suffix') || 'billed today';
      var bM = mpop.getAttribute('data-billed-m') || 'Billed monthly';
      var moTag = '<span class="mo">/mo</span>';
      var mpMoney = function (v) { v = Math.round(v * 100) / 100; return mCur + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };
      var perMo = function (total, months) { return mCur + Math.round(total / months) + moTag; };
      var setPlan = function (sel, price, per) {
        var row = mpop.querySelector('[data-plan="' + sel + '"]'); if (!row) return;
        var pe = row.querySelector('[data-mp-price]'); if (pe) pe.innerHTML = price;
        var xe = row.querySelector('[data-mp-per]'); if (xe && per != null) xe.textContent = per;
      };
      var renderMp = function (collars) {
        var i = (parseInt(collars, 10) || 1) - 1;
        var m = parseFloat(mM[i]) || 0, y = parseFloat(mY[i]) || 0, t = parseFloat(mT[i]) || 0;
        setPlan('t', perMo(t, divT), mpMoney(t) + ' ' + bSuf);
        setPlan('y', perMo(y, divY), mpMoney(y) + ' ' + bSuf);
        setPlan('m', mCur + Math.round(m) + moTag, bM);
      };
      var seg = mpop.querySelector('[data-mp-seg]');
      if (seg) {
        seg.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            seg.querySelectorAll('button').forEach(function (x) { x.classList.remove('is-on'); });
            b.classList.add('is-on'); renderMp(b.getAttribute('data-collars'));
          });
        });
      }
      var openMp = function () { renderMp(1); if (seg) { seg.querySelectorAll('button').forEach(function (x, ix) { x.classList.toggle('is-on', ix === 0); }); } mpop.hidden = false; mpop.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
      var closeMp = function () { mpop.classList.remove('is-open'); mpop.hidden = true; document.documentElement.style.overflow = ''; };
      mpop.querySelectorAll('[data-mpop-close]').forEach(function (c) { c.addEventListener('click', closeMp); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mpop.classList.contains('is-open')) closeMp(); });
      root.querySelectorAll('.pdp-note a').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); openMp(); }); });
      renderMp(1);
    }

    // "See all plans" fallback → smooth-scroll (when popup disabled)
    var plansTarget = root.getAttribute('data-plans-target');
    if (!mpop) {
      root.querySelectorAll('.pdp-note a[href*="#"]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var href = a.getAttribute('href') || '';
          var sel = href.slice(href.indexOf('#'));
          if (sel === '#' && plansTarget) { sel = plansTarget; }
          var target = sel && sel.length > 1 ? document.querySelector(sel) : null;
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        });
      });
    }

    // Add to cart via AJAX, then open the theme's side cart drawer
    var form = root.querySelector('form[data-pdp-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        var btn = form.querySelector('.pdp-atc');
        if (btn) btn.classList.add('is-loading');
        fetch(base + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            var c = (window.Alpine && window.Alpine.store) ? window.Alpine.store('cart') : null;
            if (c) { if (c.getCart) c.getCart(); if (c.show) c.show(); }
            else { window.location.href = base + 'cart'; }
          })
          .catch(function () { form.submit(); })
          .then(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    }
    var stickyAdd = root.querySelector('[data-pdp-sticky-add]');
    if (stickyAdd && form) { stickyAdd.addEventListener('click', function () { if (form.requestSubmit) { form.requestSubmit(); } else { var b = form.querySelector('.pdp-atc'); if (b) b.click(); } }); }

    // Sticky bar: show once the main Add-to-Cart has scrolled out of view (upward)
    var sticky = root.querySelector('[data-pdp-sticky]');
    var mainAtc = form ? form.querySelector('.pdp-atc') : null;
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        var en = es[0];
        sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
      }, { threshold: 0 });
      io.observe(mainAtc);
    }
  }
  function run() { document.querySelectorAll('[data-pdp-root]:not([data-pdp-bound])').forEach(function (r) { r.setAttribute('data-pdp-bound', '1'); initPdp(r); }); }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-comparison"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('[data-pt-reveal]:not(.pt-observed)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { e.classList.add('pt-observed'); io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); }
  else { document.addEventListener('DOMContentLoaded', reveal); }
  document.addEventListener('shopify:section:load', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pt-haptic]');
    if (t && navigator.vibrate) { try { navigator.vibrate(10); } catch (err) {} }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-offer-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  function run() {
    document.querySelectorAll('[data-oc-root]:not([data-oc-bound])').forEach(function (r) {
      r.setAttribute('data-oc-bound', '1');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { threshold: 0.35 });
        io.observe(r);
      } else { r.classList.add('is-in'); }
    });
    document.querySelectorAll('[data-pt-haptic]:not([data-h-bound])').forEach(function (b) {
      b.setAttribute('data-h-bound', '1');
      b.addEventListener('pointerdown', function () { if (navigator.vibrate) { try { navigator.vibrate(10); } catch (e) {} } }, { passive: true });
    });
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-payoff-converge"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    var gps = root.querySelector('.cv__path--gps');
    var radio = root.querySelector('.cv__path--radio');
    var gpsDot = root.querySelector('.cv__pulse--gps');
    var radioDot = root.querySelector('.cv__pulse--radio');
    var block = root.querySelector('.cv__block');
    if (!gps || !radio) return;
    var gpsLen = gps.getTotalLength();
    var radioLen = radio.getTotalLength();
    gps.style.strokeDasharray = gpsLen; gps.style.strokeDashoffset = gpsLen;
    radio.style.strokeDasharray = radioLen; radio.style.strokeDashoffset = radioLen;

    function clamp(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
    function draw(path, len, dot, t) {
      path.style.strokeDashoffset = len * (1 - t);
      if (dot) {
        if (t > 0.001 && t < 0.999) {
          var pt = path.getPointAtLength(len * t);
          dot.setAttribute('cx', pt.x); dot.setAttribute('cy', pt.y); dot.style.opacity = '1';
        } else { dot.style.opacity = '0'; }
      }
    }
    root._cvUpdate = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = root.getBoundingClientRect();
      var center = r.top + r.height / 2;
      // delayed: stays at 0 until the band is well into view (centre above ~78% down), then plays
      var p = clamp((vh * 0.78 - center) / (vh * 0.46));
      var gpsT = clamp((p - 0.04) / 0.40);
      var radioT = clamp((p - 0.40) / 0.40);
      draw(gps, gpsLen, gpsDot, gpsT);
      draw(radio, radioLen, radioDot, radioT);
      block.classList.toggle('gps-on', gpsT > 0.7);
      block.classList.toggle('radio-on', radioT > 0.7);
      block.classList.toggle('both-on', gpsT > 0.7 && radioT > 0.3);
      block.classList.toggle('locked', p > 0.92);
    };
    root._cvUpdate();
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      document.querySelectorAll('[data-cv-root]').forEach(function (r) { if (r._cvUpdate) r._cvUpdate(); });
    });
  }
  function run() {
    document.querySelectorAll('[data-cv-root]:not([data-cv-bound])').forEach(function (r) { r.setAttribute('data-cv-bound', '1'); setup(r); });
    if (!window.__ptCvBound) { window.__ptCvBound = true; window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll, { passive: true }); }
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-payoff-equation"] && !Shopify.designMode) return;
  try {
    
(function () {
  function run() {
    var nodes = document.querySelectorAll('.pt-payoff[data-pm-root]:not([data-pm-bound])');
    if (!nodes.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.4 }) : null;
    nodes.forEach(function (r) { r.setAttribute('data-pm-bound', '1'); if (io) { io.observe(r); } else { r.classList.add('is-in'); } });
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-payoff-lines"] && !Shopify.designMode) return;
  try {
    
(function () {
  function run() {
    var nodes = document.querySelectorAll('.pt-payoff[data-pm-root]:not([data-pm-bound])');
    if (!nodes.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.4 }) : null;
    nodes.forEach(function (r) { r.setAttribute('data-pm-bound', '1'); if (io) { io.observe(r); } else { r.classList.add('is-in'); } });
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-payoff-merge"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.4 });
      io.observe(root);
    } else { root.classList.add('is-in'); }
  }
  function run() { document.querySelectorAll('[data-pm-root]:not([data-pm-bound])').forEach(function (r) { r.setAttribute('data-pm-bound', '1'); reveal(r); }); }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-problem"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('[data-pt-reveal]:not(.pt-observed)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (e) { e.classList.add('pt-observed'); io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', reveal); }
  document.addEventListener('shopify:section:load', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-recovery-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function play(poster) {
    var media = poster.closest('[data-rs-media]');
    if (!media) return;
    var vid = media.querySelector('[data-rs-vid]');
    var embed = media.querySelector('[data-rs-embed]');
    if (vid) {
      poster.style.display = 'none';
      vid.classList.add('is-on');
      var v = vid.querySelector('video');
      if (v) { try { v.play(); } catch (e) {} }
    } else if (embed) {
      poster.style.display = 'none';
      if (!embed.querySelector('iframe')) {
        var ifr = document.createElement('iframe');
        ifr.src = embed.getAttribute('data-src');
        ifr.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        ifr.setAttribute('allowfullscreen', '');
        embed.appendChild(ifr);
      }
      embed.classList.add('is-on');
    }
  }
  function run() {
    document.querySelectorAll('[data-rs-poster]:not([data-rs-bound])').forEach(function (p) {
      p.setAttribute('data-rs-bound', '1');
      p.addEventListener('click', function () { play(p); });
      p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(p); } });
    });
    document.querySelectorAll('[data-rs-root]:not([data-rs-revbound])').forEach(function (r) {
      r.setAttribute('data-rs-revbound', '1');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { threshold: 0.2 });
        io.observe(r);
      } else { r.classList.add('is-in'); }
    });
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function revealAll() {
    var els = document.querySelectorAll('[data-pt-reveal]:not(.pt-observed)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (e) { e.classList.add('pt-observed'); io.observe(e); });
  }
  function initRev(root) {
    if (root.dataset.revInit) return;
    root.dataset.revInit = '1';
    var track = root.querySelector('.rev__track');
    if (!track) return;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;
    function step() {
      var card = track.querySelector('.rev__card');
      if (!card) return track.clientWidth;
      var gap = parseInt(getComputedStyle(track).columnGap || '0', 10) || 0;
      return card.offsetWidth + gap;
    }
    function go(dir) {
      var s = step();
      if (dir > 0 && track.scrollLeft + track.clientWidth + 5 >= track.scrollWidth) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (dir < 0 && track.scrollLeft <= 5) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
      else { track.scrollBy({ left: dir * s, behavior: 'smooth' }); }
    }
    var p = root.querySelector('[data-rev-prev]'); if (p) p.addEventListener('click', function () { go(-1); });
    var n = root.querySelector('[data-rev-next]'); if (n) n.addEventListener('click', function () { go(1); });
    var timer = null;
    function start() { if (autoplay && !reduce && !timer) timer = setInterval(function () { go(1); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true });
    start();
  }
  function run() { revealAll(); document.querySelectorAll('[data-rev-root]').forEach(initRev); }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('[data-pt-reveal]:not(.pt-observed)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (e) { e.classList.add('pt-observed'); io.observe(e); });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', reveal); }
  document.addEventListener('shopify:section:load', reveal);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-sticky-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function update() {
    document.querySelectorAll('[data-stl-root]').forEach(function (sec) {
      var total = parseInt(sec.getAttribute('data-total'), 10) || 1;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var stick = sec.querySelector('.stl__sticky');
      var stickH = stick ? stick.offsetHeight : vh;
      var scrollable = sec.offsetHeight - stickH;
      var top = sec.getBoundingClientRect().top;
      // start the build when the heading is ~45% down the screen, then track scroll directly (no dead head/tail)
      var range = scrollable + vh * 0.45;
      var prog = range > 0 ? ((vh * 0.45 - top) / range) : 0;
      prog = prog < 0 ? 0 : (prog > 1 ? 1 : prog);
      // spread the steps so the build finishes around 90% of the scroll (only a tiny tail before release)
      var K = total > 1 ? (total - 1) / 0.9 : 1;
      var idx = Math.floor(prog * K);
      if (idx > total - 1) idx = total - 1;
      // build once, then latch: once fully built it stays built (no rewind on scroll up)
      if (idx >= total - 1) sec._stlDone = true;
      if (sec._stlDone) { idx = total - 1; prog = 1; }
      sec.style.setProperty('--p', prog.toFixed(4));
      sec.classList.toggle('stl--payoff', idx === total - 1);
      sec.classList.toggle('stl--done', sec._stlDone === true);
      sec.querySelectorAll('.stl__item').forEach(function (it) {
        var i = parseInt(it.getAttribute('data-i'), 10);
        var state = i < idx ? 'done' : (i === idx ? 'current' : 'future');
        if (!it.classList.contains(state)) {
          it.classList.remove('done', 'current', 'future');
          it.classList.add(state);
        }
      });
    });
  }
  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(function () { ticking = false; update(); }); } }
  function run() {
    update();
    if (!window.__ptStlBound) {
      window.__ptStlBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal() {
    var els = document.querySelectorAll('[data-pt-reveal]:not(.pt-observed)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { e.classList.add('pt-observed'); io.observe(e); });
  }
  // Scroll-linked fill: each row's line + dot fill as it scrolls up past ~66% of the viewport
  function fill() {
    if (reduce) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var line = vh * 0.66;
    document.querySelectorAll('.pt-tl__cell').forEach(function (cell) {
      var r = cell.getBoundingClientRect();
      if (!r.height) return;
      var p = (line - r.top) / r.height;
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      cell.style.setProperty('--seg', p.toFixed(3));
      var ds = p * 5; ds = ds > 1 ? 1 : ds;
      cell.style.setProperty('--dot-s', ds.toFixed(3));
    });
  }
  var ticking = false;
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(function () { ticking = false; fill(); }); } }
  function run() {
    reveal(); fill();
    if (!window.__ptTlBound) {
      window.__ptTlBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    }
  }
  if (document.readyState !== 'loading') { run(); }
  else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-truth"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-pt-countup'));
    if (isNaN(target)) return;
    var from = parseFloat(el.getAttribute('data-pt-from'));
    if (isNaN(from)) from = 0;
    if (reduce) { el.textContent = target; return; }
    var dur = 1200, start = null, dec = (target % 1 !== 0 || from % 1 !== 0) ? 1 : 0;
    el.textContent = from.toFixed(dec);
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = (from + (target - from) * e).toFixed(dec);
      if (p < 1) { requestAnimationFrame(step); } else { el.textContent = target.toFixed(dec); }
    }
    requestAnimationFrame(step);
  }
  function reveal() {
    var els = document.querySelectorAll('.pt-truth [data-pt-reveal]:not(.pt-observed)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-visible'); });
      document.querySelectorAll('[data-pt-countup]').forEach(countUp);
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          en.target.querySelectorAll('[data-pt-countup]').forEach(countUp);
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.6, rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (e) { e.classList.add('pt-observed'); io.observe(e); });
  }
  function editorReplay(root) {
    (root || document).querySelectorAll('.pt-stat').forEach(function (c) {
      c.classList.remove('pt-observed');
      c.classList.add('is-visible');
      c.querySelectorAll('[data-pt-countup]').forEach(countUp);
    });
  }
  if (document.readyState !== 'loading') { reveal(); } else { document.addEventListener('DOMContentLoaded', reveal); }
  document.addEventListener('shopify:section:load', function (e) { reveal(); if (window.Shopify && window.Shopify.designMode) { editorReplay(e.target); } });
  document.addEventListener('shopify:section:select', function (e) { if (window.Shopify && window.Shopify.designMode) { editorReplay(e.target); } });
  if (window.Shopify && window.Shopify.designMode) { setTimeout(function () { editorReplay(document); }, 150); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pettracer-vs-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVS(root) {
    var head = root.querySelector('.vs-head');
    if (!head) return;
    function setH() { root.style.setProperty('--vs-head-h', head.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH);
    window.addEventListener('load', setH);
    if (window.ResizeObserver) { new ResizeObserver(setH).observe(head); }
  }
  function run() { document.querySelectorAll('[data-vs-root]:not([data-vs-bound])').forEach(function (r) { r.setAttribute('data-vs-bound', '1'); initVS(r); }); }
  if (document.readyState !== 'loading') { run(); } else { document.addEventListener('DOMContentLoaded', run); }
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();
})();
